<template>
  <div class="min-w-[320px]">
    <h3 class="scroll-m-20 text-2xl font-semibold tracking-tight py-5 flex items-center">
      <Button @click="$router.back()" variant="ghost" size="icon" class="p-0 m-0">
        <Icon name="lucide:chevron-left" class="w-6 h-6 p-0 m-0" />
      </Button>
      <span class="ml-2">Forgot Password</span>
    </h3>

    <form @submit="forgot" :validation-schema="formSchema" class="">
      <FormField v-slot="{ componentField }" name="email">
        <FormItem v-auto-animate>
          <!-- <FormLabel>Email</FormLabel> -->
          <FormControl>
            <Input v-bind="componentField" :disabled="loading" autocomplete="email" type="text" placeholder="Email" />
          </FormControl>
          <FormMessage class="font-light ml-3" />
        </FormItem>
      </FormField>


      <Button @click.stop.prevent="forgot" :disabled="errors.email || loading" variant="destructive" type="submit"
        :class="['text-[1em] mt-3 w-full', { 'bg-green-600 ': authSuccess }, {'pointer-events-none': authSuccess}]">
        <Loader2 v-if="loading" class="w-4 h-4 mr-2 animate-spin" />
        <icon name="lucide:check" class="w-4 h-4 mr-2" v-if="authSuccess" />
        {{authSuccess ? 'Submitted' : 'Reset Password'}}
      </Button>
    </form>


    <div class="mt-4 max-w-[200px]">
      <p class="text-green-600">{{ authSuccess }}</p>
    </div>

  </div>
</template>

<script setup lang="ts">
import { useForm } from 'vee-validate'
import { toTypedSchema } from '@vee-validate/zod'
import * as z from 'zod'
import { Button } from '@/components/ui/button'
import { Loader2 } from 'lucide-vue-next'
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form'
import { Input } from '@/components/ui/input'
// import { vAutoAnimate } from '@formkit/auto-animate'

const router = useRouter()



definePageMeta({
  layout: "auth"
})
useHead({
  title: 'Forgot Password'
})

const email = ref('')
const client = useSupabaseClient()
const loading = ref(false)
const authSuccess = ref('')
const authError = ref('')

const config = useRuntimeConfig()

const formSchema = toTypedSchema(z.object({
    email: z.string().email(),
}))


const apiErrors = ref({
  wrongCredentials: false,
  Provider: false,
  accountNotVerified: false,
  accountSuspended: false
})

const apiErrorMessages = computed(() => {
    return {
        email: apiErrors.value.wrongCredentials ? 'Invalid email' : '',
    };
});

const { validate, errors, resetForm, handleSubmit, setErrors, meta: formMeta } = useForm({
    validationSchema: formSchema
})



const forgot = handleSubmit(async (values) => {
    loading.value = true
    const validator = await validate();
    if (validator.valid) {
        const { error } = await client.auth.resetPasswordForEmail(values.email, {
            redirectTo: `${window.location.origin}/new-password`
        })
        if (error) {  
            loading.value = false    
            push({
              title: 'Error',
              message: `${error.message}`
            });
        }
        else {
          loading.value = false
            push({
              title: 'Forgot Password',
              message: `If an account exists with that email address, you will receive instructions on how to reset your password`
            });
            
            
        }
        // Set the error messages
        if (apiErrors.value.wrongCredentials){
            setErrors({
                email: apiErrorMessages.value.email
            })
            // Clear the error messages after 5 seconds
            
        }
    }    
})






const resetPassword = async () => {
    loading.value = true
  const { error }  = await client.auth.resetPasswordForEmail(email.value, {
      redirectTo: `${config.auth_origin}/new-password`
  })
    if (error) {
    console.log(error)
    loading.value = false
    authError.value = 'Invalid email credential'
    setTimeout(() => {
      authError.value = ''
    }, 5000)
  }
  else {
    loading.value = false
    authSuccess.value = `We've sent your an email.`
    setTimeout(() => {
      authSuccess.value = ''
    }, 5000)
  }
}

const clearError = () => {
  authError.value = '';
};

</script>
